// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione/articoli-padre?societaId',
    requestBody: null,
    response: '[{id,codice,descrizioneBase,umVenditaSimbolo}]'
  },
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione/tipologie?societaId',
    requestBody: null,
    response: '[{valore,label}]'
  },
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione/categorie?societaId&q',
    requestBody: null,
    response: '[{id,nome}]'
  },
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione?societaId&q',
    requestBody: null,
    response: '[{id,codice,nome,articoloPadreCodice,articoloPadreNome,umVenditaSimbolo,nComponenti}]'
  },
  {
    method: 'DELETE',
    endpoint: '/api/modelli-configurazione/:id',
    requestBody: null,
    response: '{success:true}'
  },
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione/:id',
    requestBody: null,
    response: '{id,codice,nome,descrizioneTemplate,componenti:[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/modelli-configurazione/:id',
    requestBody: null,
    response: '{id,codice,nome,descrizioneTemplate,componenti:[...]}'
  },
  {
    method: 'POST',
    endpoint: '/api/modelli-configurazione',
    requestBody: '{societaId,nome,articoloPadreId,descrizioneTemplate,componenti:[...]}',
    response: 'modello completo'
  },
  {
    method: 'PUT',
    endpoint: '/api/modelli-configurazione/:id',
    requestBody: '{nome,articoloPadreId,descrizioneTemplate,componenti:[...]}',
    response: 'modello completo'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
